import { useMemo } from "react";

import dayjs from "@/lib/dayjs";
import type { ContactMessageItem } from "@/lib/gql/__generated__/graphql";

type Props = {
	createdAt: ContactMessageItem["createdAt"];
};

export const FromNowText = ({ createdAt }: Props) => {
	const fromNow = useMemo(() => {
		return dayjs(createdAt).fromNow();
	}, [createdAt]);

	return <p className="text-sm text-zinc-500">{fromNow}</p>;
};

FromNowText.displayName = "FromNowText";
